import {Injectable} from '@angular/core';

/**
 * Fabryka użytkowników
 * @param {object} $filter             filter
 * @param {object} $q                  q
 * @param {object} SynchronizeService  SynchronizeService
 */
@Injectable()
export abstract class UserService {

    protected user: any = null;

    /**
     * Funkcja do zwracania użytkownika
     * @return {Object} Użytkownik
     */
    get() {
        if (!this.user) {
            this.loadUser();
        }
        return this.user;
    }

    get loggedIn() {
        return typeof this.user !== 'undefined' && this.user !== null && this.user.id != null && localStorage.getItem('token');
    }

    get offerModuleAccess() {
        return typeof this.user !== 'undefined' && this.user !== null && (this.user.dealerOfferingModuleAccess || ['dealer', 'dealerh', 'dealerm'].indexOf(this.user.access) === -1);
    }

    get b2c() {
        const user = this.get();
        return !user || !user.access || user.access == 'klient';
    };

    /**
     * Ładuje dane użytkownika.
     */
    abstract loadUser();

    abstract setUser(user);

    abstract synchronizeUser(): Promise<any>;

}
